/**
 * Small Sample Size: Planets */

export const planets = [
  { name: 'Mercury', groupId: 'group_1' },
  { name: 'Venus', groupId: 'group_1' },
  { name: 'Earth', groupId: 'group_1' },
  { name: 'Mars', groupId: 'group_1' },
  { name: 'Jupiter', groupId: 'group_2' },
  { name: 'Saturn', groupId: 'group_2' },
  { name: 'Uranus', groupId: 'group_2' },
  { name: 'Neptune', groupId: 'group_2' },
  { name: 'Pluto', groupId: 'group_3' },
  { name: 'Makemake', groupId: 'group_3' },
  { name: 'Haumea', groupId: 'group_3' },
  { name: 'Quaoar', groupId: 'group_3' },
  { name: 'Orcus', groupId: 'group_3' },
]

export const planetGroups = [
  { name: 'Inner planets', id: 'group_1' },
  { name: 'Outer planets', id: 'group_2' },
  { name: 'Kuiper belt', id: 'group_3' },
]

/**
 *  Medium Sample Size: Vegetable-like */

// Sometimes we call things vegetables that aren't
type VegBiology = 'fruit' | 'fungus' | 'berry'

type VegGroups = {
  biology?: VegBiology
  id: number
  name: string
}

export const veggieGroups: VegGroups[] = [
  { name: 'Vegetables', id: -1 },
  { name: 'Legumes', id: 1 },
  { name: 'Cabbage', id: 2 },
  { name: 'Greens', id: 3 },
  { name: 'Herbs', id: 4 },
  { name: 'Lettuce', id: 5 },
  { name: 'Onions', id: 6 },
  { name: 'Peppers', id: 7, biology: 'berry' },
  { name: 'Root vegetables', id: 8 },
  { name: 'Squashes', id: 9, biology: 'fruit' },
]

type Veg = {
  aka?: string[]
  biology?: VegBiology
  category: number
  name: string
}

/**
 * @see https://simple.wikipedia.org/wiki/List_of_vegetables
 */
export const veggies: Veg[] = [
  { name: 'Artichoke', category: -1 },
  { name: 'Asparagus', category: -1 },
  {
    name: 'Aubergine',
    aka: ['Eggplant'],
    biology: 'fruit',
    category: -1,
  },
  { name: 'Broccoli', category: -1 },
  { name: 'Brussels sprouts', category: -1 },
  { name: 'Cauliflower', category: -1 },
  { name: 'Celery', category: -1 },
  { name: 'Endive', category: -1 },
  { name: 'Fiddleheads', category: -1 },
  { name: 'Frisee', category: -1 },
  { name: 'Fennel', category: -1 },
  { name: 'Mushrooms', biology: 'fungus', category: -1 },
  { name: 'Nettles', category: -1 },
  { name: 'New Zealand spinach', category: -1 },
  { name: 'Okra', category: -1 },
  { name: 'Radicchio', category: -1 },
  { name: 'Rhubarb', category: -1 },
  { name: 'Skirret', category: -1 },
  { name: 'Sweetcorn', category: -1 },
  { name: 'Topinambur', category: -1 },
  { name: 'Spinach', category: -1 },
  { name: 'Tat soi', category: -1 },
  { name: 'Tomato', biology: 'fruit', category: -1 },
  { name: 'Watercress', category: -1 },
  { name: 'Alfalfa sprouts', category: 1 },
  { name: 'Azuki beans', aka: ['Adzuki'], category: 1 },
  { name: 'Bean sprouts', category: 1 },
  { name: 'Black beans', category: 1 },
  { name: 'Black-eyed peas', category: 1 },
  { name: 'Borlotti bean', category: 1 },
  { name: 'Broad beans', category: 1 },
  { name: 'Garbanzo beans', aka: ['Chickpeas', 'Ceci beans'], category: 1 },
  { name: 'Green beans', category: 1 },
  { name: 'Kidney beans', category: 1 },
  { name: 'Lentils', category: 1 },
  { name: 'Lima beans', aka: ['Butter bean'], category: 1 },
  { name: 'Mung beans', category: 1 },
  { name: 'Navy beans', category: 1 },
  { name: 'Peanuts', category: 1 },
  { name: 'Pinto beans', category: 1 },
  { name: 'Runner beans', category: 1 },
  { name: 'Split peas', category: 1 },
  { name: 'Soy beans', category: 1 },
  { name: 'Peas', category: 1 },
  { name: 'Snap peas', aka: ['Mange tout'], category: 1 },
  { name: 'Kohlrabi cabbage', category: 2 },
  { name: 'Savoy cabbage', category: 2 },
  { name: 'Red cabbage', category: 2 },
  { name: 'Bok choy', category: 3 },
  { name: 'Chard', aka: ['Beet greens'], category: 3 },
  { name: 'Collard greens', category: 3 },
  { name: 'Kale', category: 3 },
  { name: 'Mustard greens', category: 3 },
  { name: 'Anise', category: 4 },
  { name: 'Basil', category: 4 },
  { name: 'Caraway', category: 4 },
  { name: 'Coriander', category: 4 },
  { name: 'Chamomile', category: 4 },
  { name: 'Daikon', category: 4 },
  { name: 'Dill', category: 4 },
  { name: 'Fennel', category: 4 },
  { name: 'Lavender', category: 4 },
  { name: 'Lemongrass', aka: ['Xymbopogon'], category: 4 },
  { name: 'Marjoram', category: 4 },
  { name: 'Oregano', category: 4 },
  { name: 'Parsley', category: 4 },
  { name: 'Rosemary', category: 4 },
  { name: 'Thyme', category: 4 },
  { name: 'Lettuce', category: 5 },
  { name: 'Arugula', category: 5 },
  { name: 'Chives', category: 6 },
  { name: 'Garlic', category: 6 },
  { name: 'Leek', category: 6 },
  { name: 'Onion', category: 6 },
  { name: 'Shallot', category: 6 },
  { name: 'Scallion', aka: ['Green onion', 'Spring onion'], category: 6 },
  { name: 'Bell pepper', category: 7 },
  { name: 'Chili pepper', category: 7 },
  { name: 'Jalapeño', category: 7 },
  { name: 'Habanero', category: 7 },
  { name: 'Paprika', category: 7 },
  { name: 'Tabasco pepper', category: 7 },
  { name: 'Cayenne pepper', category: 7 },
  { name: 'Beet', aka: ['Beetroot'], category: 8 },
  { name: 'Carrot', category: 8 },
  { name: 'Celeriac', category: 8 },
  { name: 'Corms', category: 8 },
  { name: 'Eddoe', category: 8 },
  { name: 'Konjac', category: 8 },
  { name: 'Taro', category: 8 },
  { name: 'Water chestnut', category: 8 },
  { name: 'Ginger', category: 8 },
  { name: 'Parsnip', category: 8 },
  { name: 'Rutabaga', category: 8 },
  { name: 'Radish', category: 8 },
  { name: 'Wasabi', category: 8 },
  { name: 'Horseradish', category: 8 },
  { name: 'Daikon', aka: ['White radish'], category: 8 },
  { name: 'Jicama', category: 8 },
  { name: 'Jerusalem artichoke', category: 8 },
  { name: 'Potato', category: 8 },
  { name: 'Sweet potato', category: 8 },
  { name: 'Yam', category: 8 },
  { name: 'Turnip', category: 8 },
  { name: 'Acorn squash', category: 9 },
  { name: 'Bitter melon', category: 9 },
  { name: 'Butternut squash', category: 9 },
  { name: 'Banana squash', category: 9 },
  { name: 'Cucumber', category: 9 },
  { name: 'Delicata', category: 9 },
  { name: 'Gem squash', category: 9 },
  { name: 'Hubbard squash', category: 9 },
  { name: 'Squash', aka: ['Marrow'], category: 9 },
  { name: 'Spaghetti squash', category: 9 },
  { name: 'Zucchini', category: 9 },
]

export const getALotOfVeggies = (times = 10) => {
  let veggiesPile: Veg[] = []
  for (let i = 0; i < times; i++) {
    veggies.forEach((veg) => {
      const newVeg = { ...veg }
      newVeg.name = `${veg.name}-${i}`
      veggiesPile.push(newVeg)
    })
  }
  return veggiesPile
}
